// Mask all except last N characters
export const maskValue = (value, visibleChars = 2) => {
    if (!value) return "";

    const str = value.toString();
    if (str.length <= visibleChars) return str;

    const maskedLength = str.length - visibleChars;
    return "*".repeat(maskedLength) + str.slice(-visibleChars);
};

// Mask email like ****@gmail.com
export const maskEmail = (contact_email) => {
    if (!contact_email) return "";

    const [name, domain] = contact_email.split("@");
    return "*".repeat(name.length) + "@" + domain;
};

// Mask name (first letter visible)
export const maskName = (name) => {
    if (!name) return "";

    return name[0] + "*".repeat(name.length - 1);
};